import { t } from '../helpers/t-converter'

export const monitoringFilters = (type: string): string => {
  return type === 'true' ? t('Проводиться моніторинг') : t('Не враховувати моніторинги')
}
